<template>
  <div>
    <v-client-table
      class="fixed_header" ref="tabListeAutresreseaux"
      :data="reseaux"
      :columns="columns"
      :options="options"
      @filter="tableIsFilter">
      <div slot="nbFaces" slot-scope="props">
        <div class="is-pulled-right">{{props.row.nbFaces}}</div>
      </div>
      <div slot="zoom" slot-scope="props" style="text-align:center">
        <b-button
          class="has-background-transparent no_border pa-0"
          @click="zoomReseau(props.row)"
          :disabled="!isValidLatLng(props.row.latitude, props.row.longitude)">
          <b-icon icon="google-maps" type="is-primary"/>
        </b-button>
      </div>
      <div slot="fichepdf" slot-scope="props" style="text-align:center">
        <a @click="exporterFicheProduit(props.row)">
          <b-icon icon="file-pdf" type="is-danger"></b-icon>
        </a>
      </div>
    </v-client-table>
    <b-modal
      v-model="isComponentOuvrirListeFaces"
      has-modal-card
      class="modal modal-liste-faces"
      width="80vw">
      <Consultation
        :reseau="reseau"
        :disabled="disabled"
        :no-update="true"
        :horsSecteur="true"
        :index-tabs="1"/>
    </b-modal>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import gestionErreur from '@/services/general/gestionErreur';
import { TEXTS, PER_PAGE_VALUE } from '@/configuration/clientTableConf';
import * as types from '@/store/creationOpportunite/venteReseauxTempo-mutation-type';
import exporterFicheProduit from '@/services/reseauxTempo/exporterFicheProduit';
import Consultation from '@/components/creationOpportunite/panier/composantsProduits/venteReseauxTempo/consultation';

const VenteReseauxTempo = createNamespacedHelpers('venteReseauxTempo');
const ReseauxTempo = createNamespacedHelpers('reseauxTempo');

export default {
  name: 'listeAutresReseaux',
  components: {
    Consultation,
  },
  data() {
    return {
      trad: {
        libelle: '↑↓ Libelle',
        ville: '↑↓ Ville',
        nbFaces: '↑↓ Nb Faces prévues ',
        format: '↑↓ Format',
        jourDepartLibelle: '↑↓ Départ',
        zoom: 'Carto',
        code: '↑↓ Code',
        fichepdf: 'PDF',
        isComponentOuvrirListeFaces: false,
      },
      reseau: null,
      isComponentOuvrirListeFaces: false,
      disabled: true,
    };
  },
  watch: {
    reseaux(val) {
      this.actionsUpdateMarkerReseauFilter(val);
    },
  },
  computed: {
    ...VenteReseauxTempo.mapGetters({
      getActiveTabReseau: 'activeTabReseau',
    }),
    ...ReseauxTempo.mapGetters({
      reseaux: 'reseaux',
    }),
    columns() {
      return ['code', 'libelle', 'ville', 'format', 'jourDepartLibelle', 'nbFaces', 'zoom', 'fichepdf'];
    },
    options() {
      return {
        headings: {
          libelle: this.trad.libelle,
          ville: this.trad.ville,
          nbFaces: this.trad.nbFaces,
          format: this.trad.format,
          jourDepartLibelle: this.trad.jourDepartLibelle,
          zoom: this.trad.zoom,
          code: this.trad.code,
          fichepdf: this.trad.fichepdf,
        },
        filterByColumn: true,
        filterable: ['code', 'libelle', 'ville', 'format', 'jourDepartLibelle', 'nbFaces'],
        perPageValues: PER_PAGE_VALUE,
        perPage: 99999,
        texts: TEXTS,
        columnsClasses: {
          format: 'has-text-centered',
          jourDepartLibelle: 'has-text-centered',
          fichepdf: 'colonneBoutonFaceLcListe ellipsis has-text-centered',
          zoom: 'colonneBoutonFaceLcListe has-text-centered',
        },
        customSorting: {
          jourDepartLibelle(ascending) {
            return (a, b) => {
              if (ascending) {
                return a.jourDepart >= b.jourDepart ? 1 : -1;
              }
              return a.jourDepart <= b.jourDepart ? 1 : -1;
            };
          },
        },
      };
    },
  },
  methods: {
    ...VenteReseauxTempo.mapMutations({
      setActiveTabReseau: types.SET_ACTIVE_TAB_RESEAU,
      setZoomMarker: types.SET_ZOOM_MARKER,
    }),
    ...VenteReseauxTempo.mapActions({
      actionsUpdateMarkerReseauFilter: 'updateMarkerReseauFilter',
    }),
    zoomReseau(reseau) {
      this.reseau = reseau;
      this.isComponentOuvrirListeFaces = true;
    },
    async exporterFicheProduit(data) {
      const loadingComponent = this.$buefy.loading.open({ container: null });
      try {
        await exporterFicheProduit(data);
        loadingComponent.close();
      } catch (e) {
        gestionErreur(`Erreur lors de la generation du PDF du réseau id: ${data.num}`, e);
        loadingComponent.close();
      }
    },
    tableIsFilter() {
      this.$emit('liste', {
        data: this.$refs.tabListeAutresreseaux.filteredData,
        type: 'reseauxTempo',
      });
    },
  },
  mounted() {
    this.tableIsFilter();
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/creationOpportunite/venteReseauxTempo/recherche/listeAutresReseaux.vue